import React,{useState,useEffect} from 'react'
import qs from 'qs';
import {useHistory} from "react-router-dom";
import axios from 'axios';
import {TextField,Stack ,MenuItem,FormControl,Select,InputLabel,
  Box, IconButton }from '@material-ui/core';
 
import Modal from '../Generales/ModalTam';
import {llamadaApiToken,ErrorGeneral,llamaApiCargaToken } from '../funciones/ClienteAxios';
import {printConsole} from '../funciones/ConsolaLog'
import moment from 'moment';
import {toast} from 'react-toastify';

const NvoEditAseguradora = ({modalAbierto, setModalAbierto, registro,Buscar}) => {
  const Dispvo =localStorage.getItem('Dispvo') ;    
  const auxDispV =Dispvo.length >= 12 ? Dispvo:'451224452121'  
  const history = useHistory();
  const usuId =localStorage.getItem('UsuId') ; 
  const hoy=moment(new Date()).format('YYYY-MM-DD')
  const source = axios.CancelToken.source();            
  const [espera,setEspera]= useState(false);
  const [listTipo,setListTipo]= useState([])  
  const [aviso,setAviso]= useState(false)  
  const [listAseguradora,setListAseguradora]= useState([])  
  const [btnDeshabilitado,setBtnDeshabilitado]= useState(true)  
 
  const [contadorToast,setContadorToast]= useState(0)  
  const [seguro,setSeguro]= useState({Tipo:'',
    FIni:hoy, FFin:hoy, 
    Representa:'', Descripcion:'',  Aseguradora:"", Nota:"", Sigla:""})
  const{Tipo,  FIni, FFin,  Representa, Descripcion,  
    Aseguradora, Nota, Sigla  }=seguro
  
  useEffect(() => {    
 
    if (registro.length!==0) {
      setSeguro({...seguro, Tipo: registro.TpId, Sigla:registro.Sigla,
        Descripcion: registro.Descr, Aseguradora:registro.AsegId, Nota:registro.Notas
      })
    }
    return () => {
      source.cancel();
    }

  }, [])
  
 
  const llamadaApi = () => {                       
    const data = qs.stringify({
        Usuario:usuId, 
        Llave:registro.length!==0 ? registro.Id : 0,
        Sigla:Sigla,    
        Status:1,
        Descr:Descripcion,
        idDispositivo: auxDispV,
    });
    
    const url = "/maquinaria/seguro/aseguradora/new-edit";
    function respuesta(auxiliar){            
      if ( auxiliar) 
      {                 
        Buscar()
        let mensaje=registro.length!==0 ? "Se edito correctamente la aseguradora":"Se creo correctamente la aseguradora"
        //setTipoAdvertencia("success")      
        //setMensaje(mensaje);
        //setAviso(true)     
        toast.success(`${mensaje}`,{
            pauseOnFocusLoss: false,
            theme: "colored",
            toastId: `exito-env`
        })  

        setModalAbierto(false)    
      }     
        
    }
    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
  };  

  const onChangeDate=(e)=>{
    if (e.target.value!=="" && e.target.value!==null && e.target.value!==undefined 
      
    ) {
      if (e.target.value.length===10 && parseInt(e.target.value.substring(0,4 ))>=1900  ) 
      {
        if (e.target.name==="FIni" ) {
          setSeguro({...seguro,[e.target.name] : e.target.value,
            FFirma:e.target.value+"T09:00",
          })    
        }else{
          setSeguro({...seguro,[e.target.name] : e.target.value})  
        }
        
      }      
    } 
     
    printConsole(e.target.value)    
    printConsole(e.target.value.length)
  }

  const onChange=(e)=>{
    
    if (e.target.name==="Tipo") 
    {
      setSeguro({...seguro,[e.target.name] : e.target.value, })
     
    }
    else
    {
      setSeguro({...seguro,[e.target.name] : e.target.value})
    }
    
  }

  const selectTipo= <FormControl style={{   width: "10rem" ,marginRight:1+'rem'}} size="small">
    <InputLabel id="ipt-tipo">Tipo</InputLabel>
    <Select
      labelId="lbl-select-tipo" id="select-tipo" name="Tipo"
      value={Tipo} label="Tipo" onChange={onChange}
    >      
      {listTipo.map((tipo)=><MenuItem value={tipo.Id}>{tipo.Descr}</MenuItem>)}
    </Select>
  </FormControl>

  const selectAseguradora= <FormControl style={{  width: "17rem"}} size="small">
    <InputLabel id="ipt-aseguradora">Aseguradora</InputLabel>
    <Select
      labelId="lbl-select-aseguradora" id="select-aseguradora" name="Aseguradora"
      value={Aseguradora} label="Aseguradora" onChange={onChange}
    >      
      {listAseguradora.map((element)=><MenuItem value={element.Id}>{element.Descr}</MenuItem>)}
    </Select>
  </FormControl>

  const verificaNulos = (campo,descripcion)=>{
    let respuesta =false;               
    if( (typeof campo !== 'number' && typeof campo === 'string' 
        && (campo.trim() === '' || campo.trim() === null ))
        || campo === null
    ) 
    { let mensaje='No se lleno el campo '+descripcion      
      toast.warning(`${mensaje}`,{
        pauseOnFocusLoss: false, theme: "colored",
        toastId: `error-env ${contadorToast}`
      })  
      setContadorToast(contadorToast+1)
      respuesta =true
    }    
    return(respuesta);
  }

  const guardarDatos=()=>{    
      
    if (Sigla.length>=3 ||  !verificaNulos("","Sigla")) 
    {
      if (Descripcion.length>=3  ||  !verificaNulos("","Descripción")) 
      { 
        //console.log(Tipo);
        
        llamadaApi()
      }
    }
    
  }
  
 
  return (
  <Modal
    titulo={registro.length!==0 ? `Editar Aseguradora ${registro.Poliza}` :"Nueva Aseguradora"} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    tamanio="md" btnDeshabilitado={false} cargando={espera}
    setCargando={setEspera} setAviso={setAviso}
  >
    <Box component="form"  style={{width:"28rem"}}>
 
       
      <TextField
        label="Sigla" id="Sigla-campo" 
        value={Sigla} name="Sigla" maxLength={10}
        size="small" style={{width:"10rem", marginBottom:"1rem"}} onChange={onChange}
      />  
      <Box >
 
      </Box>
    {/*   <TextField
        id="datetime-Firma" label="Fecha Firma" size='small'
        type="datetime-local" name="FFirma" value={FFirma} 
        onChange={onChangeDate} style={{ width: 290 }} 
        InputLabelProps={{ shrink: true, }}
      /> */}
      <Box display={"flex"} flexDirection={"column"}>
        <TextField
          id="outlined-multiline-static" label="Descripción" variant='outlined'
          multiline rows={3} name="Descripcion" onChange={onChange} maxLength={150}
          value={Descripcion} size='small' style={{marginRight:"1rem", marginTop:"1rem"}}
        />
   
      </Box>
    </Box>
  </Modal>
  )
}

export default NvoEditAseguradora